import type { MailboxInfo } from 'owa-client-ids';

export function getReadingPaneRouteForPopoutV2(
    mailboxInfo: MailboxInfo,
    itemId?: string,
    conversationId?: string,
    internetMessageId?: string
) {
    let route = '';
    if (internetMessageId) {
        route = 'readimid/';
        route += encodeURIComponent(btoa(internetMessageId));
    } else {
        route = conversationId ? 'readconv/' : 'read/';

        if (mailboxInfo && mailboxInfo.type == 'GroupMailbox') {
            route += 'group/';
            const emailAddressParts = mailboxInfo.mailboxSmtpAddress.split('@');
            route += `${emailAddressParts[1]}/${emailAddressParts[0]}/`;
        }

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (25,37): Argument of type 'string | undefined' is not assignable to parameter of type 'string | number | boolean'.
        // @ts-expect-error
        route += encodeURIComponent(conversationId ? conversationId : itemId);
    }

    return route;
}
